import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPQantDebeso = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("image", {
		width: 18,
		height: 18,
		href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABIElEQVR4AayRza3CQAyEx9AKNIDeAW5JGU+il0AvSJRBbnBAUAC0EsyONxuFZUMSRBRnf2J/smcm+NHzHWitGf71YMG9a2YUaHG8bVwNUKGAILPgHsAg0N/xli1Od4VI4WqSby+IkIfIwapVt7ZOsYWitOAeAzqqQhcOclnN/Wg7KbGX3IL7PhA1ESBToGwgrij1+tGofOQCIai7mbpuXorX2uFahQKRC6ghBFAjis3gebBrFNgKRnz8aFS+5cJ5NS/V6RI4l+VMQthdlM87D6LykQvX5SxHrY3pxewQiXwPCgnR2jjl9HqDRbkfQcydqOZcKX4D63TNMtMf6hVGJMyyEi73dsRCjsjO2gbwvh2DQCxgZ2YAD52u8eeYSLj2BAAA//+Xj037AAAABklEQVQDAFYsniXNlfdHAAAAAElFTkSuQmCC"
	})
});
export default SvgPQantDebeso;
